import { createTheme } from '@mui/material/styles'

type PaletteMode = 'light' | 'dark'

// Gemeinsame Typografie-Einstellungen
const typography = {
  button: {
    fontSize: '1rem',
    textTransform: 'none' as const,
    letterSpacing: '0.01em'
  },
  h1: {
    fontSize: '3.5rem',
    fontWeight: 500,
    letterSpacing: '-0.01em'
  },
  h2: {
    fontSize: '3rem',
    fontWeight: 500,
    letterSpacing: '0.01em'
  },
  h3: {
    fontSize: '2.5rem',
    fontWeight: 700,
    letterSpacing: '-0.02em'
  },
  h4: {
    fontSize: '2rem',
    fontWeight: 700
  },
  h5: {
    fontSize: '1.75rem',
    fontWeight: 500
  },
  h6: {
    fontSize: '1.5rem'
  },
  subtitle1: {
    fontSize: '1.25rem'
  },
  body2: {
    fontSize: '0.875rem'
  }
}

// Light Mode Palette (Original-Farbschema)
const lightPalette = {
  mode: 'light' as PaletteMode,
  primary: {
    main: '#3c0f98'
  },
  secondary: {
    main: '#b1f005',
    dark: '#9ad200'
  },
  text: {
    primary: '#180b32',
    secondary: 'rgba(0,0,0,0.8)'
  }
}

// Dark Mode Palette
const darkPalette = {
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#7c4dff',
    light: '#b47cff',
    dark: '#3f1dcb'
  },
  secondary: {
    main: '#c6ff00',
    dark: '#9ad200'
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255,255,255,0.7)'
  },
  background: {
    default: '#121212',
    paper: '#1e1e1e'
  }
}

// Theme-Factory-Funktion
export const createAppTheme = (mode: PaletteMode) => {
  return createTheme({
    palette: mode === 'light' ? lightPalette : darkPalette,
    typography
  })
}

// Standard Light Theme für Rückwärtskompatibilität
const customTheme = createAppTheme('light')

export default customTheme
